import debounce from 'debounce';

import schema from './schema';

const getState = () => {
    const { location: { hash } } = window;
    if (!hash) {
        return {};
    }
    try {
        const res = JSON.parse(
            decodeURIComponent(escape(atob(hash.replace('#', '')))),
        );

        const vld = schema.validate(res);
        if (Object.prototype.hasOwnProperty.call(vld, 'error')) {
            console.error('Malformed URL data!', vld.error);
            return {};
        }

        return res;
    } catch (error) {
        console.error('Malformed URL data!', error);
        return {};
    }
};

const setState = debounce((state) => {
    const b64State = btoa(unescape(encodeURIComponent(JSON.stringify(state))));
    window.location.hash = `#${b64State}`;
}, 1000);

export default () => {
    let cache = null;

    const getCachedState = () => {
        if (!cache) {
            cache = getState();
        }

        return cache;
    };

    return {
        getItem(key) {
            const { [key]: value } = getCachedState();
            return value;
        },

        setItem(key, value) {
            const state = getCachedState();
            state[key] = value;
            setState(state);
        },

        removeItem(key) {
            const state = getCachedState();
            delete state[key];
            setState(state);
        },
    };
};
